import { API_CALL } from '../actions/types';
import { client } from '../actions/client';
import { authenticate, unauthenticate } from '../actions/authActions';

const signIn = (store, next) => {
  const { user } = store.getState();
  const isLoggedIn = user ? user.isLoggedIn : false;
  if (!isLoggedIn) {
    next(authenticate());
  }
};

const failAction = (action, err, extra = {}) => ({
  ...action,
  type: action.onError,
  error: err,
  apiCallWorkflow: 'error',
  ...extra
});

const requestMiddleware = store => next => action => {
  if (action.type !== API_CALL && !action.payload) {
    return next(action);
  }
  next({ ...action, type: action.onRequest, apiCallWorkflow: 'request' });
  return client.request(action.payload)
    .then(res => {
      signIn(store, next);
      if (action.responseKey) {
        action[action.responseKey] = res.data;
      } else {
        action.payload = res.data;
      }
      if (action.sideEffect !== undefined) {
        action.sideEffect(res.data);
      }
      next({ ...action, type: action.onResponse, apiCallWorkflow: 'response' });
    })
    .catch(err => {
      if (err.response && (err.response.status === 403 || err.response.status === 401)) {
        return next(unauthenticate());
      }
      if (!action.onError) {
        return Promise.reject(err);
      }
      if (err.response && err.response.status > 399) {
        return next(failAction(action, err, { status: err.response.status }));
      }
      if (!err.response) {
        err.status = err.code === 'ECONNABORTED' ? 408 : 590;
        return next(failAction(action, err, { status: err.status }));
      }
      return next(failAction(action, err, { status: err.response.status || 0 }));
    })
};

export default requestMiddleware;
